import { Stores } from '../models/Stores';

export class BaseStore {
    stores: Stores;

    constructor(stores: Stores) {
        this.stores = stores;
    }

    /**
     * Return a URL object based on the current url in the browser
     *
     * @readonly
     */
    get currentUrl(): URL {
        return new URL(document.location.toString());
    }

    get currentUrlKey(): string {
        // To prevent confusion on the deprecated notice on the node btoa
        return window.btoa(
            `${this.currentUrl.host}${this.currentUrl.pathname}`
        );
    }
}



// WEBPACK FOOTER //
// ./src/stores/BaseStore.ts